module.exports = __webpack_public_path__ + "gfx/TS-9.png";